module.exports = __webpack_public_path__ + "static/media/human-fsu.25c8134b.png";